import { useEffect, useState } from "react";
import * as api from "../api/client";
import { usePolledResource } from "../hooks/usePolling";
import { MessageLogsList } from "../components/MessageLogsList";

const POLL_INTERVAL_MS = 20_000;

export function MessageLogs() {
  const { data: serversData, loading: serversLoading } = usePolledResource(api.listServers, null);
  const [selectedServerId, setSelectedServerId] = useState<string | null>(null);

  const servers = serversData?.servers ?? [];

  useEffect(() => {
    if (!selectedServerId && servers.length > 0) {
      setSelectedServerId(servers[0].id);
    }
  }, [servers, selectedServerId]);

  const fetcher = () =>
    selectedServerId ? api.listMessageLogs(selectedServerId) : Promise.resolve({ logs: [] });
  const { data, loading, error } = usePolledResource(
    fetcher,
    selectedServerId ? POLL_INTERVAL_MS : null,
    selectedServerId ?? undefined
  );

  return (
    <>
      <div className="topbar">
        <div className="page-title-group">
          <h1>Message Logs</h1>
          <p>Delivery records for messages sent via the Command Bar (per-server Status tab), plus the data model for future inbound server/client messages.</p>
        </div>
      </div>

      <div className="panel">
        <div className="panel-header">
          <h2>Select a server</h2>
        </div>

        {serversLoading ? (
          <p className="muted">Loading servers…</p>
        ) : servers.length === 0 ? (
          <p className="muted">No servers registered yet.</p>
        ) : (
          <select
            className="input"
            style={{ maxWidth: "320px" }}
            value={selectedServerId ?? ""}
            onChange={(e) => setSelectedServerId(e.target.value)}
          >
            {servers.map((s) => (
              <option key={s.id} value={s.id}>
                {s.display_name} ({s.id})
              </option>
            ))}
          </select>
        )}
      </div>

      <div className="panel">
        <div className="panel-header">
          <h2>Logs</h2>
        </div>
        {error && <div className="form-error">{error}</div>}
        {loading ? <p className="muted">Loading…</p> : <MessageLogsList logs={data?.logs ?? []} />}
      </div>
    </>
  );
}
